import environment from "web/script/modules/environment";

export function getURL(patternName: string): string | undefined {
    return environment.get("urlPatterns")[patternName];
}
